import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext, useMemo, useEffect } from 'react'
import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import getLoyaltyTargetUpgradePackage from 'loyalty/lib/getLoyaltyTargetUpgradePackage'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'

/**
 * This is a temporary measure for MVP where a user selects a target upgrade
 * that is no longer available in the calendar then the calendar picker is closed.
 * This choice was the best of a bad set of options and will optimised post MVP
 * to work with multi-room & multi-cart as well.
 *
 * @TODO: refactor the selectedUpgradeKey to just be the packageUniqueKey
 */
function useLoyaltyOfferPageClearTargetRoomUpgrade(
  packageView: OfferPackageOptionView | undefined,
) {
  const originPackage = packageView?.package
  const { loyaltyTargetRoomUpgradesSelected, offer, checkInDate, activeFilter } = useContext(OfferPageStateContext)
  const targetUpgradePackage = getLoyaltyTargetUpgradePackage(offer, originPackage)
  const offerPageDispatch = useOfferPageDispatch()
  const isMobileDevice = useIsMobileDevice()

  const selectedUpgradeKey = useMemo(() => {
    if (!originPackage) return undefined
    return buildLoyaltySelectedUpgradeKey(originPackage, targetUpgradePackage)
  }, [originPackage, targetUpgradePackage])

  useEffect(() => {
    if (
      selectedUpgradeKey &&
      loyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] &&
      (checkInDate && (!activeFilter || (isMobileDevice && activeFilter === 'packageSelection')) && !packageView?.hasLoyaltyTargetUpgradeAvailable)
    ) {
      offerPageDispatch({
        type: OfferPageActions.toggleLoyaltyTargetRoomUpgrade,
        selectedUpgradeKey,
        hasSelectedTargetRoomUpgrade: false,
      })
    }
  }, [
    activeFilter,
    checkInDate,
    isMobileDevice,
    loyaltyTargetRoomUpgradesSelected,
    offerPageDispatch,
    packageView?.hasLoyaltyTargetUpgradeAvailable,
    selectedUpgradeKey,
  ])
}

export default useLoyaltyOfferPageClearTargetRoomUpgrade
